import { render, staticRenderFns } from "./classroomList.vue?vue&type=template&id=577d2da2&scoped=true&"
import script from "./classroomList.vue?vue&type=script&lang=js&"
export * from "./classroomList.vue?vue&type=script&lang=js&"
import style0 from "./classroomList.vue?vue&type=style&index=0&id=577d2da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d2da2",
  null
  
)

export default component.exports